<template>
    <div class="users-container">
        <!-- Filtros Avançados -->
        <AdvancedFilters 
            ref="advancedFilters"
            :show-date-filter="true"
            :show-course-filter="false"
            :show-user-filter="true"
            :show-status-filter="false"
            @filters-applied="onFiltersApplied"
            @filters-cleared="onFiltersCleared"
        />

        <Loader v-if="!hasReady" />
        <div v-else>
            <v-table class="custom-table table-with-filters">
                <thead>
                    <tr>
                        <th style="width: 60%; text-align: left;" class="sortable-header" @click="sortBy('title')">
                            {{ $t('admin.reports.columns.title') }}
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 20%; text-align: left;" class="sortable-header" @click="sortBy('date')">
                            {{ $t('admin.reports.columns.date') }}
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                        <th style="width: 20%; text-align: center;" class="sortable-header" @click="sortBy('status')">
                            {{ $t('admin.reports.columns.status') }}
                            <fa icon="fa-solid fa-sort" class="sort-icon" />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="forum in paginatedCourses" :key="forum.id">
                        <td style="width: 60%; text-align: left;">{{ forum.title }}</td>
                        <td style="width: 20%; text-align: left;">{{ formatDate(forum.dateInsert) }}</td>
                        <td style="width: 20%; text-align: center;">
                            <v-chip
                                density="compact"
                                :color="forum.status == 1 ? 'success' : 'warning'"
                            >
                                {{ forum.status == 1 ? $t('admin.reports.status.open') : $t('admin.reports.status.closed') }}
                            </v-chip>
                        </td>
                    </tr>
                </tbody>
            </v-table>
        </div>

        <div class="pagination users-pagination">
            <v-responsive>
                <v-pagination
                    :model-value="currentPage + 1"
                    :length="totalPages"
                    :total-visible="5"
                    :disabled="!hasReady"
                    @update:model-value="onPageChange"
                ></v-pagination>
            </v-responsive>
        </div>
    </div>
</template>

<script>
    import Loader from '@/components/Loader/loader.vue';
    import AdvancedFilters from '@/components/Admin/Reports/AdvancedFilters.vue';
    import api from '@/utils/reports.js';
    import { mapState } from 'vuex';
import { toast } from 'vue3-toastify';

    export default {
        data() {
            return {
                label: this.labels,
                forumsFiltered: [],
                currentPage: 0,
                pageSize: 10,
                totalElements: 0,
                alertOpenCourse: false,
                removedcoursename: '',
                afterWidth: 40,
                allForums: [],
                openModalCreateWarning: false,
                openModalEditWarning: false,
                hasReady: false,
                indiceItem: [false, false, false, true],
                isMobileIcon: false,
                totalPages: 0,
                currentSort: { field: '', order: 'asc' },
                activeFilters: {}, // Armazenar filtros ativos para export
            };
        },
        props: {
            labels: Array,
            searchTerm: String
        },
        computed: {
            ...mapState(['token', 'numberIntensTable']),
            paginatedCourses() {
                // Retornar todos os dados da página atual (já vem paginado da API)
                return this.forumsFiltered || [];
            },
        },
        watch: {
            searchTerm(newTerm) {
                this.filteredForums(newTerm);
            },
            status(newStatus) {
                console.log('Status changed:', newStatus);
                this.filteredForumStatus(newStatus);
            },
        },
        methods: {
            async exportToCSV() {
                try {
                    toast.info(this.$t('admin.reports.exporting'));
                    
                    // Preparar filtros para a API de export
                    const exportFilters = {};
                    
                    if (this.activeFilters.userName) {
                        exportFilters.userName = this.activeFilters.userName;
                    }
                    if (this.activeFilters.title) {
                        exportFilters.title = this.activeFilters.title;
                    }
                    if (this.activeFilters.startDate) {
                        exportFilters.startDate = this.activeFilters.startDate;
                    }
                    if (this.activeFilters.endDate) {
                        exportFilters.endDate = this.activeFilters.endDate;
                    }
                    
                    // Chamar endpoint de export
                    const response = await api.getDataForumExport(this.token, exportFilters);
                    
                    // Fazer download do arquivo blob
                    const url = window.URL.createObjectURL(response);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'relatorio_forum.csv');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    toast.success(this.$t('admin.reports.exportSuccess'));
                } catch (error) {
                    toast.error(this.$t('admin.reports.exportError'));
                    console.error('Erro ao exportar CSV:', error);
                }
            },
            formatDate(dateString) {
                const date = new Date(dateString);
                const day = String(date.getUTCDate()).padStart(2, '0');
                const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() returns month from 0 to 11
                const year = date.getUTCFullYear();
                return `${day}/${month}/${year}`;
            },
            async getDataReport(searchTerm = '') {
                try {
                    this.hasReady = false;
                    
                    const filters = {};
                    
                    // Se houver searchTerm, buscar por título do fórum
                    if (searchTerm && searchTerm.trim() !== '') {
                        filters.title = searchTerm.trim();
                    }
                    
                    const pagination = {
                        page: this.currentPage,
                        size: this.pageSize
                    };
                    
                    console.log('forum.vue - buscando dados com filtros:', filters, 'pagination:', pagination);
                    
                    const response = await api.getDataForum(this.token, filters, pagination);
                    console.log('forum.vue - resposta da API:', response);
                    
                    // Processar resposta (mesmo que vazia)
                    this.allForums = response?.content || [];
                    this.forumsFiltered = response?.content || [];
                    this.totalPages = response?.totalPages || 0;
                    this.totalElements = response?.totalElements || 0;
                    
                    this.hasReady = true;
                    
                    // Mostrar mensagem se não houver resultados
                    if (this.forumsFiltered.length === 0 && searchTerm) {
                        toast.info(this.$t('admin.reports.noSearchResults'));
                    }
                } catch (error) {
                    toast.error(this.$t('admin.reports.loadError'));
                    console.error('Erro Report Fórum', error);
                    // Garantir que mesmo em caso de erro, os dados sejam limpos
                    this.allForums = [];
                    this.forumsFiltered = [];
                    this.totalPages = 0;
                    this.totalElements = 0;
                    this.hasReady = true;
                }
            },
            filteredForums(searchTerm) {
                if (!searchTerm || searchTerm.trim() === '') {
                    this.forumsFiltered = this.allForums;
                } else {
                     this.forumsFiltered = this.allForums.filter((forum) =>
                forum.title &&
                forum.title.toLowerCase().includes(searchTerm.toLowerCase())
            );
                }
                return this.forumsFiltered;
            },
            filteredForumStatus(status) {
                if (status == 'all') {
                    this.forumsFiltered = this.allForums;
                } else {
                    this.forumsFiltered = this.allForums.filter(
                        (forum) =>
                            forum.status == status
                    );
                }
                return this.forumsFiltered;
            },
            async onPageChange(page) {
                // Converter de 1-based (UI) para 0-based (API)
                this.currentPage = page - 1;
                await this.getDataReport();
            },
            filterByDate(period, index) {
                this.indiceItem = this.indiceItem.map((item, i) =>
                    i === index ? true : false
                );
                const now = new Date();
                let startDate;

                switch (period) {
                    case 'today':
                        startDate = new Date(now.setHours(0, 0, 0, 0));
                        break;
                    case 'last30days':
                        startDate = new Date(now.setDate(now.getDate() - 30));
                        break;
                    case 'last90days':
                        startDate = new Date(now.setDate(now.getDate() - 90));
                        break;
                    case 'alltime':
                        this.forumsFiltered = this.allForums;
                        return;
                }
                this.forumsFiltered = this.allForums.filter((forum) => {
                    const forumDate = new Date(forum.dateInsert);
                    return forumDate >= startDate;
                });
            },
            filterByCustomDate(event) {
                const selectedDate = new Date(event.target.value);
                if (!selectedDate) {
                    this.forumsFiltered = this.allForums;
                }
                this.forumsFiltered = this.allForums.filter((forum) => {
                    const forumDate = new Date(forum.dateInsert);
                    return forumDate >= selectedDate;
                });
            },
            onFiltersApplied(filters) {
                this.applyAdvancedFilters(filters);
            },
            onFiltersCleared() {
                this.clearAdvancedFilters();
            },
            async applyAdvancedFilters(filters) {
                try {
                    this.hasReady = false;
                    
                    // Armazenar filtros ativos para export
                    this.activeFilters = { ...filters };
                    if (filters.dateFrom) this.activeFilters.startDate = filters.dateFrom;
                    if (filters.dateTo) this.activeFilters.endDate = filters.dateTo;
                    
                    // Preparar filtros para a API
                    const apiFilters = {};
                    
                    // Filtro por nome do usuário/título do fórum
                    if (filters.userName && filters.userName.trim() !== '') {
                        apiFilters.userName = filters.userName.trim();
                    }
                    if (filters.title && filters.title.trim() !== '') {
                        apiFilters.title = filters.title.trim();
                    }
                    
                    // Filtro por data
                    if (filters.dateFrom) {
                        apiFilters.startDate = filters.dateFrom;
                    }
                    if (filters.dateTo) {
                        apiFilters.endDate = filters.dateTo;
                    }
                    
                    const pagination = {
                        page: this.currentPage,
                        size: this.pageSize
                    };
                    
                    // Buscar dados da API com os filtros
                    console.log('Aplicando filtros via API (fórum):', apiFilters, 'pagination:', pagination);
                    const response = await api.getDataForum(this.token, apiFilters, pagination);
                    
                    // Processar resposta da API (mesmo que vazia)
                    let filteredData = response?.content || [];
                    this.allForums = filteredData; // Atualizar dados base
                    
                    this.forumsFiltered = filteredData;
                    this.totalPages = response?.totalPages || 0;
                    this.totalElements = response?.totalElements || 0;
                    
                    this.hasReady = true;
                    
                    // Mostrar mensagem se não houver resultados
                    if (filteredData.length === 0) {
                        toast.info(this.$t('admin.reports.noFilterResults'));
                    }
                    
                } catch (error) {
                    toast.error(this.$t('admin.reports.filtersApplyError'));
                    console.error('Erro ao aplicar filtros:', error);
                    // Garantir que mesmo em caso de erro, os dados sejam limpos
                    this.forumsFiltered = [];
                    this.allForums = [];
                    this.totalPages = 0;
                    this.totalElements = 0;
                    this.hasReady = true;
                }
            },
            async clearAdvancedFilters() {
                try {
                    this.hasReady = false;
                    this.currentPage = 0;
                    
                    const pagination = {
                        page: this.currentPage,
                        size: this.pageSize
                    };
                    
                    // Buscar todos os dados novamente sem filtros
                    const response = await api.getDataForum(this.token, {}, pagination);
                    this.allForums = response?.content || [];
                    this.forumsFiltered = response?.content || [];
                    this.totalPages = response?.totalPages || 0;
                    this.totalElements = response?.totalElements || 0;
                    this.hasReady = true;
                } catch (error) {
                    console.error('Erro ao limpar filtros:', error);
                    this.forumsFiltered = [];
                    this.allForums = [];
                    this.totalPages = 0;
                    this.totalElements = 0;
                    this.hasReady = true;
                }
            },
            sortBy(field) {
                if (this.currentSort.field === field) {
                    this.currentSort.order = this.currentSort.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.currentSort.field = field;
                    this.currentSort.order = 'asc';
                }
                
                this.forumsFiltered = this.sortData([...this.forumsFiltered], field, this.currentSort.order);
            },
            sortData(data, sortBy, sortOrder) {
                return data.sort((a, b) => {
                    let aValue, bValue;
                    
                    switch (sortBy) {
                        case 'title':
                            aValue = a.title.toLowerCase();
                            bValue = b.title.toLowerCase();
                            break;
                        case 'date':
                            aValue = new Date(a.dateInsert);
                            bValue = new Date(b.dateInsert);
                            break;
                        case 'status':
                            aValue = parseInt(a.status) || 0;
                            bValue = parseInt(b.status) || 0;
                            break;
                        default:
                            return 0;
                    }
                    
                    if (sortOrder === 'asc') {
                        return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
                    } else {
                        return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
                    }
                });
            },
        },
        components: {
            Loader,
            AdvancedFilters
        },
        async created() {
            await this.getDataReport();
        },
    };
</script>

<style scoped>

    .search-form-input {
        position: relative;
        width: 100%;
    }
    .title-container {
        position: relative;
        margin-bottom: 10px;
        padding-bottom: 0;
        border-bottom: 1px solid #f0f0f0;
        text-align: left;
    }

    .title-container .title {
        font-size: 1.5rem;
        font-weight: 700;
        color: #000000;
        margin-bottom: 0.5rem;
    }

    .title-container .subtitle {
        color: #6b7280;
        font-size: 0.875rem;
        line-height: 1.4;
        margin-bottom: 1rem;
    }

    .export-button-container {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 1rem;
        margin-top: 1rem;
    }

    .export-button-container .btn-weflix {
        background-color: #2f2e8b;
        color: white;
        padding: 0.75rem 1.5rem;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-weight: 600;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
        border: none;
    }

    .export-button-container .btn-weflix:hover:not(:disabled) {
        background-color: #23225f;
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(47, 46, 139, 0.3);
    }

    .export-button-container .btn-weflix:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    }

    .export-button-container .btn-weflix svg {
        font-size: 1rem;
    }

    .search-row {
        display: flex;
        gap: 0.75rem;
        margin-bottom: 1.5rem;
    }

    .search-row .form-group {
        flex: 1;
    }

    .btn-weflix.absolute {
        position: absolute;
        top: 0;
        right: 0;
        background-color: #2f2e8b;
        color: white;
        padding: 0.5rem 1rem;
        border-radius: 6px;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-weight: 600;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px rgba(47, 46, 139, 0.2);
    }

    .btn-weflix.absolute:hover {
        background-color: #23225f;
        transform: translateY(-2px);
    }

    .users-table-responsive {
        background-color: #ffffff;
        border-radius: 8px;
        margin-bottom: 1rem;
    }

    .users-table {
        width: 100%;
        border-collapse: separate;
        border-spacing: 0;
    }

    .users-table th {
        background-color: #f8fafc;
        padding: 0.75rem;
        font-weight: 600;
        color: #4a5568;
        text-align: left;
        border-bottom: 2px solid #e2e8f0;
    }

    .users-table td {
        padding: 0.75rem;
        vertical-align: middle;
        border-bottom: 1px solid #f0f0f0;
        color: #4a5568;
    }

    .users-table tr:hover {
        background-color: #f8fafc;
    }

    .badge-active,
    .badge-inactive {
        padding: 0.25rem 0.75rem;
        border-radius: 5px;
        font-size: 0.75rem;
        font-weight: 500;
        display: inline-block;
        text-align: center;
        transition: all 0.2s ease;
        width: fit-content;
    }

    .badge-active {
        background-color: #7bcc8180;
        color: #4b614e;
    }

    .badge-inactive {
        background-color: #d7d7ee80;
        color: #2f2e8b;
    }

    .dark .badge-active,
    .dark .badge-inactive {
        color: #fff;
    }

    .user-btn-edit {
        padding: 0.4rem;
        margin: 0 0.25rem;
        border: none;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.2s ease;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 32px;
        height: 32px;
        color: #2f2e8b;
    }

    .search-form-input {
        position: relative;
    }

    .search-form-control {
        width: 100%;
        padding: 0.5rem 0.75rem;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        font-size: 0.875rem;
        transition: all 0.2s ease;
    }

    .search-form-control:focus {
        outline: none;
        border-color: #2f2e8b;
        box-shadow: 0 0 0 3px rgba(47, 46, 139, 0.1);
    }

    .search-input-icon {
        position: absolute;
        right: 0.75rem;
        top: 45%;
        transform: translateY(-50%);
        color: #9ca3af;
        cursor: pointer;
    }

    .users-pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1rem;
        margin-top: 1rem;
        padding-bottom: 10px;
    }

    .users-page-btn {
        padding: 0.5rem 1rem;
        border: 1px solid #e2e8f0;
        border-radius: 6px;
        background: white;
        color: #4a5568;
        cursor: pointer;
        transition: all 0.2s;
    }

    .users-page-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .users-page-btn:not(:disabled):hover {
        background: #f8fafc;
        border-color: #cbd5e0;
    }

    .users-page-info {
        color: #4a5568;
        font-size: 0.875rem;
    }

    @media (max-width: 768px) {

        .title-container {
            margin-bottom: 1.5rem;
        }

        .search-row {
            flex-direction: column;
        }

        .users-table th,
        .users-table td {
            padding: 0.5rem;
        }
    }

    @media (max-width: 600px) {
        .btn-weflix.absolute {
            padding: 0.5rem;
        }

        .btn-weflix.absolute span {
            display: none;
        }

        .users-table-responsive {
            overflow-x: auto;
        }
    }

    select.form-control.filter-form-control {
        width: 60%;
    }
    .form-group.filter-form-group {
        justify-content: space-around;
        align-items: center;
        margin: 0 !important;
    }
    .form-group.search-form-group {
        margin: 0 !important;
    }
    table.table.users-table {
        border: none !important;
        padding: 0 !important;
    }
    button.btn-edit.user-btn-edit svg {
        color: #2f2e8b;
    }
    .form-group.filter-form-group {
        display: flex;
    }
    .btn-weflix.absolute span.flex {
        font-size: 16px;
    }
    .btn-weflix.absolute svg {
        color: white;
        font-size: 15px;
    }
    /* DARK */
    .dashboard.dark .users-table-responsive {
        background-color: #000 !important;
    }
    .dashboard.dark .weeducAdminReports .page-info.users-page-info {
        color: white;
    }
    .dashboard.dark .weeducAdminReports .users-table th {
        border-bottom: 2px solid #575757 !important;
    }
    .dashboard.dark .weeducAdminReports .users-table td {
        border-bottom: 2px solid #575757 !important;
    }

    .sortable-header {
        cursor: pointer;
        user-select: none;
        transition: background-color 0.2s ease;
        position: relative;
    }

    .sortable-header:hover {
        background-color: #f1f3f4;
    }

    .sort-icon {
        margin-left: 0.5rem;
        opacity: 0.5;
        transition: opacity 0.2s ease;
    }

    .sortable-header:hover .sort-icon {
        opacity: 1;
    }

    .dashboard.dark .sortable-header:hover {
        background-color: #666;
    }

    .table-with-filters {
        border-radius: 0 0 6px 6px;
        border: 1px solid #e2e8f0;
        border-top: none;
        overflow: hidden;
    }

    .dashboard.dark .table-with-filters {
        border-color: #444;
    }
</style>
